import React, { FC } from 'react';

//devextreme
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';

import { useDeleteContractorObjectMutation } from 'bus/contractorObject/services';

type DetailModalContractorObjectProps = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DetailModal: FC<DetailModalContractorObjectProps> = (props) => {
  const [deleteContractorObject, { isLoading }] = useDeleteContractorObjectMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    await deleteContractorObject({ id: props.id! });
    props.refresh();
    props.changeVisible(false);
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить объект?</div>
            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => props.changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModal;
